export default {
   Gmail1: 1,
   Gmail2: 2,
   Hotmail: 3,
   OutlookMail:  4,
   YahooMail1: 5,
   YahooMail2: 6,
   Other: 7,
}